<template>
  <div>
    <Input
      @on-blur="changLocation"
      @on-clear="clear"
      clearable
      placeholder="请输入地址"
      type="text"
      v-model="address"
    >
      <Button @click="handleOpen" icon="ios-pin" slot="append" type="primary"></Button>
    </Input>
    <Modal @on-cancel="close" @on-ok="changLocation" title="地图" v-model="visible" width="80vw">
      <div class="mapContainer">
        <div class="lnglatInfo" v-if="lnglat && lnglat.length > 0">经纬度:{{ lnglat }}</div>
        <div class="searchInfo">
          关键字：
          <input autocomplete="off" id="searchKey" placeholder="请输入关键字" />
        </div>
        <div id="mapContainer"></div>
        <div id="mapResultPanel"></div>
      </div>
    </Modal>
  </div>
</template>
<script>
//高德地图
import AMapLoader from '@amap/amap-jsapi-loader'
export default {
  name: 'amapSelect',
  props: {
    default: [],
    addressDefault: ''
  },
  data () {
    return {
      visible: false,
      address: '',
      map: null,
      autoComplete: null,
      searchKey: '',
      lnglat: [],
      addressKeyWord: '',
      locationName: '',
      poiList: [],
      selectEle: null
    }
  },
  methods: {
    close: function () {
      if (this.lnglat != this.default) {
        this.lnglat = this.default
        this.handleAddMarker()
      }
      if (this.address != this.addressDefault) {
        this.address = this.addressDefault
      }
      this.visible = false
      if (this.map) this.map.clearMap()
    },
    handleOpen: function () {
      this.visible = !this.visible
      if (this.visible) {
        this.initMap()
      }
    },
    clear: function () {
      this.$emit('change', { address: '', longAndLat: this.lnglat || [] })
    },
    changLocation: function () {
      this.$emit('change', { address: this.address, longAndLat: this.lnglat })
    },
    handleAddMarker () {
      this.map.clearMap()
      if (this.lnglat && this.lnglat.length == 2) {
        // 构造点标记
        const marker = new AMap.Marker({
          // icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
          position: this.lnglat || [],
        })
        // 单独将点标记添加到地图上
        this.map.add(marker)
        this.map.setCenter(this.lnglat)
      }

    },
    initMap: function () {
      let _this = this
      AMapLoader.load({
        key: "2ae7679496c3d8aa9bc81137b39744e4",             // 申请好的Web端开发者Key，首次调用 load 时必填
        version: "2.0",      // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        // plugins: [''],       // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      }).then((AMap) => {
        let center = [105.602725, 37.076636]
        if (this.default && this.default.length == 2) center = this.default
        this.map = new AMap.Map("mapContainer", {  //设置地图容器id
          resizeEnable: true,//是否监控地图容器尺寸变化
          viewMode: "3D",    //是否为3D地图模式
          zoom: 8,           //初始化地图级别
          center: center, //初始化地图中心点位置
        })
        this.map.setCity("浙江省")

        AMap.plugin(['AMap.AutoComplete', 'AMap.PlaceSearch'], function () {
          var auto = new AMap.AutoComplete({ input: "searchKey" })

          var placeSearch = new AMap.PlaceSearch({
            pageSize: 5, // 单页显示结果条数
            pageIndex: 1, // 页码
            city: '全国',
            citylimit: true,  //是否强制限制在设置的城市内搜索
            map: _this.map, // 展现结果的地图实例
            panel: "mapResultPanel", // 结果列表将在此容器中进行展示。
            autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
          })

          auto.on("select", (e) => {
            placeSearch.setCity(e.poi.adcode)
            placeSearch.search(e.poi.name)
          })

          AMap.Event.addListener(placeSearch, 'listElementClick', function (data) {
            console.log("listElementClick", data)
            _this.selectEle = data.data || {}
            _this.address = _this.selectEle.name
            let location = _this.selectEle.location || {}
            _this.lnglat = [location.lng, location.lat]
            _this.handleAddMarker()
          })
        })

        this.map.on('click', (ev) => {
          // 触发事件的地理坐标，AMap.LngLat 类型
          var data = ev.lnglat || {}
          console.log('data', data)
          this.lnglat = [data.lng, data.lat]
          this.handleAddMarker()
          // 将经纬度坐标转化为详细地址
          AMap.plugin('AMap.Geocoder', () => {
            var geocoder = new AMap.Geocoder({
              extensions: 'all'
              // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
            })
            geocoder.getAddress([data.lng, data.lat], (status, result) => {
              if (status === 'complete' && result.info === 'OK') {
                this.address = result.regeocode.formattedAddress
                // result为对应的地理位置详细信息
                console.log('详细地址', result)
              }
            })
          })
        })
        this.handleAddMarker()
      }).catch(e => {
        console.log('initMap error', e)
      })

    }
  },
  beforeCreate () {
    window._AMapSecurityConfig = {
      securityJsCode: '8c00c33e9fa6ff7948e177e4733b1c0c',
    }
  },
  mounted () {
    this.lnglat = this.default
    this.address = this.addressDefault

  },
  beforeDestroy () {
    this.close()
    if (this.map) this.map.destroy()
  }
}
</script>

<style scoped>
/* .treePanel > div {
  padding: 0 1rem;
  cursor: pointer;
} */
.mapContainer {
  width: 100%;
  height: 60vh;
  position: relative;
}

.lnglatInfo {
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 1000;
}

.searchInfo {
  background: #fff;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
  padding: 10px;
}

#mapContainer {
  width: 100%;
  height: 100%;
}

#mapResultPanel {
  position: absolute;
  background-color: white;
  max-height: 90%;
  overflow-y: auto;
  top: 10px;
  right: 10px;
  width: 280px;
}
</style>